module.exports = __webpack_public_path__ + "img/tackled_left.74e71d16.jpg";